export const firebaseCollection = {
  INSTITUTES: 'institutes',
  CLASSES: 'classes',
  STUDENTS: 'students',
  TEACHERS: 'teachers',
  CHAT_MESSAGE: 'message_',
  USER_INFO_COLLECTION: 'user_informations'
};
